/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Confirmation_RejectedInputs */

const en_queue_sos_confirmation_rejected = /** @type {(inputs: Queue_Sos_Confirmation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order confirmations rejected by the customer`)
};

/**
* | output |
* | --- |
* | "Order confirmations rejected by the customer" |
*
* @param {Queue_Sos_Confirmation_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_confirmation_rejected = /** @type {((inputs?: Queue_Sos_Confirmation_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Confirmation_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_confirmation_rejected(inputs)
});